import React from 'react'
import "./pageLoader.scss"
const PageLoader = () => {
  return (
    <div className="page-loader-section">
      <div className="page-loader"></div>
    </div>
  )
}

export default PageLoader
